import Vue from "vue";
import apiList from "@/service/apiList";
import { Message } from "element-ui";

// 获取导出数据列表
function exportList(params) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$api
      .get(apiList.exportList, params)
      .then(function(res) {
        if (res.code === 200) {
          resolve(res.data);
        } else {
          resolve(res);
        }
      })
      .catch(function(err) {
        reject(err);
      });
  });
}

// 下载数据
// function downloadData(params) {
//   return new Promise((resolve,reject) => {
//     Vue.prototype.$api
//       .get(apiList.downloadData, params)
//       .then(function(res) {
//         if (res.code === 200) {
//           resolve(res.data);
//         } else {
//           resolve(res);
//         }
//       })
//       .catch(function(err) {
//         reject(err);
//         console.log(err);
//       });
//   });
// }
function downloadData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.downloadData, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success(
            "导出售后单成功，请在邮箱中查收!今日已导出" + res.data + "次"
          );
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
function getExportUrl(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exportUrl, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

export {
  exportList, // 获取导出列表数据
  downloadData, // 下载数据
  getExportUrl
};



// WEBPACK FOOTER //
// ./src/models/reportCenterModel.js